// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaGroup,
  $FullRegattaResultTable,
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaResultTableType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputNumber,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  regattaResultTableTypeLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $FullRegattaResultTable | $Model<'RegattaResultTable'> | $ModelUpsertParams<'RegattaResultTable'>;
  resourceData: Array<$FullRegattaGroup>;
};

const RegattaResultTableFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={8}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col xs={4}>
          <AvField
            label={t('Calculation type')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              RegattaResultTableType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaResultTableTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col xs={4}>
          <InputNumber
            label={t('Discards')}
            min={0}
            name={'Discards'}
            required
            value={item.Discards}
          />
        </Col>
        <Col xs={4}>
          <AvField
            label={t('Regatta group')}
            name={'RegattaGroupId'}
            required
            type={'select'}
            value={item.RegattaGroupId}
          >
            {item.RegattaGroupId === '' && (
              <option />
            )}
            {_.map(
              resourceData,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.AltName || i.Group.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col xs={4}>
          <InputNumber
            label={t('Start group')}
            min={0}
            name={'StartGroup'}
            value={item.StartGroup}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaResultTableFieldsView;
